import { Component } from '@angular/core';
import { ActionSheetController, IonicPage, NavController, NavParams, ModalController, Platform } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KlmrJobcardPage } from '../klmr-jobcard/klmr-jobcard';
import { SelectPrestartItemsPage } from '../select-prestart-items/select-prestart-items';
import { KlmrTimesheetCreateAddPage } from '../klmr-timesheet-create-add/klmr-timesheet-create-add';
import { SearchPage } from '../search/search';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { SelectImagePopupPage } from '../select-image-popup/select-image-popup';

@IonicPage()
@Component({
  selector: 'page-klmr-jobcard-add',
  templateUrl: 'klmr-jobcard-add.html',
})
export class KlmrJobcardAddPage {
  selectOptions: any;
  params: any;
  fleetId: any;
  isUpdate: boolean = false;
  jobCardForm: FormGroup;
  actionAllowed: boolean = false;
  vehicleType: any;
  requestedList: any = [];
  priorityList: any = [];
  statusList: any = [];
  completedList: any = [];
  jobTypeList: any = [];
  fleetList: any = [];
  preStartItemList: any = [];
  commentList: any = [];
  allPrestartData: any = [];
  prestartItemList: any = [];
  jobNumberList: any = [];

  selectedRequest: any = "Select";
  selectedPriority: any = "";
  selectedStatus: any = "Select";
  selectedCompletd: any = "Select";
  selectedJobtype: any = "Select job type";
  selectedJob: any = "";
  selectedFleet: any = "Select";

  status: any = "";
  reset:boolean = false;
  firstTime:boolean = true;
  disableSubmit:boolean = false;


  constructor(public actionSheetController: ActionSheetController, public camera: Camera, public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder, private modalController: ModalController, public platform: Platform) {
    this.selectOptions = {
      mode: 'ios'
    };
    this.params = this.navParams.get('param');
    this.fleetId = this.navParams.get('fleet');
    if (this.params) {
      console.log("params", this.params)
      this.isUpdate = true;
      this.firstTime = false;
    }
    console.log("this.fleetId", this.fleetId);


    let currentDate = new Date();
     var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;
    this.jobCardForm = this.formBuilder.group({
      user_id: new FormControl('', [Validators.required]),
      comment: new FormControl(''),
      notes: new FormControl(''),
      job_no: new FormControl('', [Validators.required]),
      plant_item: new FormControl('', [Validators.required]),
      in_date: new FormControl(date, [Validators.required]),
      job_description: new FormControl('', [Validators.required]),
      requested_by: new FormControl(''),
      priority: new FormControl(''),
      job_status: new FormControl('', [Validators.required]),
      completed_by: new FormControl(''),
      out_date: new FormControl(date),
      job_type: new FormControl('', [Validators.required]),
      service_hrs: new FormControl(''),
      machine_hrs: new FormControl(''),
      vehicle_kms: new FormControl(''),
      service_kms: new FormControl(''),
      prestart_id: new FormControl(''),
      commentValidation: this.formBuilder.array([]),
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad KlmrJobcardAddPage');
    this.getPermission();
    this.getMetaData();
  }


  async mobileUploads(index) {
    const actionSheet = await this.actionSheetController.create({
      title: 'Select Image source',
      buttons: [
        {
          text: 'Load from Library',
          handler: () => {
            this.pickImage(this.camera.PictureSourceType.PHOTOLIBRARY, index);
          },
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.pickImage(this.camera.PictureSourceType.CAMERA, index);
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
        },
      ],
    });
    await actionSheet.present();
    // this.onInput('', 'Photography');
  }

  pickImage(sourceType, index) {
    let image: any;

    const options: CameraOptions = {
      quality: 20,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
    };
    this.camera.getPicture(options).then(
      (imageData) => {
        image = 'data:image/jpeg;base64,' + imageData;
        // this.jobCardForm.value.commentValidation[index].isBase64 = true;
        // this.jobCardForm.value.commentValidation[index].finalBase64 = image;
        ((this.jobCardForm.get('commentValidation') as FormArray).at(index) as FormGroup).get("isBase64").patchValue(true);
        ((this.jobCardForm.get('commentValidation') as FormArray).at(index) as FormGroup).get("finalBase64").patchValue(image);
        this.base64tofile(image, this.jobCardForm.value.commentValidation[index].title, index);

        // this.loadingService.dismissLoading();
      },

      (err) => {
        // this.loadingService.dismissLoading();
        console.log("errOf Image ", err)
      }
    );
  }

  clearImage(i) {
    this.jobCardForm.value.commentValidation[i].file = '';
  }

  async onPhotoGraphy(event, type, index) {
    if (type == 1) {
      this.mobileUploads(index)
    } else if (type == 2) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.utiltiy.getBase64(event.target.files[i]).then(
          async (data: any) => {
            console.log("data", data);
            // this.selectedFleetItems[index].photo = data;
            ((this.jobCardForm.get('commentValidation') as FormArray).at(index) as FormGroup).get("isBase64").patchValue(true);
            ((this.jobCardForm.get('commentValidation') as FormArray).at(index) as FormGroup).get("finalBase64").patchValue(data);
            // this.jobCardForm.value.commentValidation[index].isBase64 = true;
            // this.jobCardForm.value.commentValidation[index].finalBase64 = data;

            this.base64tofile(data, this.jobCardForm.value.commentValidation[index].title, index);
          }).catch(error => {
            console.log('error', error);
          });
      }
    }
  }


  async base64tofile(base64, fileName, index) {
    const res: Response = await fetch(base64);
    const blob: Blob = await res.blob();
    const file = new File([blob], fileName.replace(/ /g, '') + `.png`, { type: 'image/png' });
    // this.jobCardForm.value.commentValidation[index].file = file
    ((this.jobCardForm.get('commentValidation') as FormArray).at(index) as FormGroup).get("file").patchValue(file);

    console.log(" this.jobCardForm.valu", this.jobCardForm.value)



  }

  async fileToBase64(file){
    let str =window.URL.createObjectURL(file);
    console.log("str",str)

  }

  async getMetaData() {
    let userId = await this.utiltiy.getStorage("userId");
    let userName = await this.utiltiy.getStorage("name");
    if (userId) {
      this.jobCardForm.get(`user_id`).setValue(userId);
    }
    if (userName) {
      this.selectedRequest = userName;
      this.jobCardForm.get(`requested_by`).setValue(userName);
    }

    if (this.fleetId) {
      // this.jobCardForm.get(`prestart_id`).setValue("0");
      // this.jobCardForm.get(`plant_item`).setValue(this.fleetId);
      // this.jobCardForm.get(`job_description`).setValue("Fleet Number " + this.fleetId);
    }
    this.utiltiy.startLoading();
    this.jobNumberList = await this.getJobNumberData();
    this.requestedList = await this.getData("requested_list");
    this.priorityList = await this.getData("priority_list");
    this.statusList = await this.getData("status_list");
    this.completedList = await this.getData("completed_list");
    this.jobTypeList = await this.getData("job_type_list");
    this.fleetList = await this.getData("fleet_no_list");
    // this.fleetList = await this.getData("fleet_no_list");

    
    if(!this.isUpdate){
      if(this.statusList.length != 0){
        this.jobCardForm.get(`job_status`).setValue(this.statusList[0].ID);
        this.selectedStatus = this.statusList[0].Status;
      }
    }

    if (this.params) {
      let prestartItems = await this.getDataPrestart("prestart_items_new_jobcard", this.params.id);
      this.prestartItemList = await this.getDataPrestartItems("prestart_items",this.fleetId);
     
      this.jobCardForm.setControl('commentValidation', this.formBuilder.array([]));
      // completedList
      for (let item of prestartItems.result) {
        let name = "Select";
        let title = "";
        let id = "";
        let photo = item.photo != null ?item.photo:"";
        let base64Status = item.photo != null ? item.photo != "" ?false:true:true;
        let dbId = item.id;

        if(item.prestart_item_name == null && item.type != "0"  && item.type != null){
          console.log("item.type",item.type)
          let itemIndex = this.prestartItemList.findIndex(list_ => list_.id == item.type);
          if(itemIndex != -1){
            title = this.prestartItemList[itemIndex].name;
            id = this.prestartItemList[itemIndex].id;
          }
        }else if(item.prestart_item_name != null){
          title = item.prestart_item_name;
          id = item.prestart_item_name;
        }

        
        let index = this.completedList.findIndex(list_ => list_.id == item.completed_by);
        if (index != -1) {
          name = this.completedList[index].Person
        }

        if(item.type){
          let completed_name_list = [];
          const commentForm = this.formBuilder.group({
            title: title,
            comment: [item.comment],
            file: [photo],
            completed_by: [item.completed_by],
            completed_name: [name],
            base64: [base64Status],
            id: id,
            dbId: dbId,
            imagePrefix: base64Status == false?prestartItems.base_url:null,
            isCheck:false,
            isBase64:false,
            finalBase64:null,
          });
          let itemList = item.completed_by.split(",")

          if(itemList.length == 0){
            let index = this.completedList.findIndex(list_ => list_.id == item.completed_by);
            if(index != -1){
              completed_name_list.push(this.completedList[index].Person)
            }
          }

          itemList.forEach(element => {
            let index = this.completedList.findIndex(list_ => list_.id == element);
            if(index != -1){
              completed_name_list.push(this.completedList[index].Person)
            }
          });
          commentForm.get(`completed_name`).setValue(completed_name_list);
          this.comments.push(commentForm)
        }
      }

      console.log("prestartItems", this.comments)
      // this.isUpdate = true;
    }else{
      let index = this.fleetList.findIndex(list_ => list_.fleet_no.toLowerCase() == this.fleetId.toLowerCase());
      if (index != -1) {
        this.prestartItemList = await this.getDataPrestartItems("prestart_items",this.fleetList[index].id);
      }
    }

    console.log("this.fleetId", this.fleetId);
    if (this.isUpdate) {
      if (this.params.job_no.length > 0) {
        let jobNo = this.params.job_no.substring(0, 1);
        this.selectedJob = jobNo;
      }
      this.getFleetData(this.fleetId, "id");
      this.checkJobType(this.params.job_type);
    } else {
      this.getFleetData(this.fleetId, "fleet_no");

    }
    this.utiltiy.stopLoading();

    // this.locationList = await this.getLocationList();
    if (this.params) {
      this.getComment(this.params.id,this.params.user_id);
      this.regenerateForm();
    }
  }

  getFleetData(id, key) {
    let index = this.fleetList.findIndex(list_ => list_[key].toLowerCase() == id.toLowerCase());
    if (index == -1) {
      return;
    } else {
      this.jobCardForm.get(`prestart_id`).setValue("0");
      this.jobCardForm.get(`plant_item`).setValue(this.fleetList[index].id);
      // this.jobCardForm.get(`job_description`).setValue("Fleet Number " + this.fleetList[index].fleet_no);
      console.log(" this.vehicleType", this.vehicleType)
      this.selectedFleet = this.fleetList[index].fleet_no;
      // if (this.firstTime) {
      //   return;
      // }
      let type = this.fleetList[index].vehicle_category
      if (type == "2" || type == "3") {
        this.jobCardForm.get(`vehicle_kms`).setValue(this.fleetList[index].current_kms);
      } else if (type == "1" || type == "4") {
        this.jobCardForm.get(`machine_hrs`).setValue(this.fleetList[index].current_hrs);
      }
      this.vehicleType = this.fleetList[index].vehicle_category;
      console.log("this.fleetList", this.fleetList[index])
    }
  }

  async regenerateForm() {
    console.log("out date :",this.params.out_date)
    if(this.params.out_date == "0000-00-00"){
      let currentDate = new Date();
      var d = new Date();
      let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
      let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
      let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
      let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
      this.params.out_date = year + "-" + month + "-" + day;
    }
    this.jobCardForm.patchValue({
      // user_id: this.params.user_id,
      comment: this.params.comment,
      job_no: this.params.job_no,
      plant_item: this.params.plant_item,
      in_date: this.params.in_date,
      job_description: this.params.job_description,
      requested_by: this.params.requested_by,
      priority: this.params.priority,
      job_status: this.params.job_status,
      completed_by: this.params.completed_by,
      out_date: this.params.out_date,
      job_type: this.params.job_type,
      service_hrs: this.params.service_hrs,
      service_kms: this.params.service_kms,
      notes: this.params.notes,
      // machine_hrs: this.params.machine_hrs,
      prestart_id: this.params.prestart_id,
    });
    // this.selectedRequest = this.params.requested_by;
    this.selectedPriority = this.params.priority;
    // this.selectedStatus = this.params.job_status;
    this.selectedJobtype = await this.getDataFromKey(this.jobTypeList, this.params.job_type, 'id', 'job_type');
    this.selectedCompletd = await this.getDataFromKey(this.completedList, this.params.completed_by, 'id', 'Person');
    this.selectedStatus = await this.getDataFromKey(this.statusList, this.params.job_status, 'ID', 'Status');
    this.selectedRequest = await this.getDataFromKey(this.requestedList, this.params.requested_by, 'name', 'name');
    this.selectedFleet = await this.getDataFromKey(this.fleetList, this.params.plant_item, 'id', 'fleet_no');
    this.checkJobType(this.selectedJobtype);

  }

  changeCheckbox(i,event){
    console.log(i,"event",event._value);
    // this.jobCardForm.value.commentValidation[i].isCheck = event._value;
    ((this.jobCardForm.get('commentValidation') as FormArray).at(i) as FormGroup).get("isCheck").patchValue(event._value);
    console.log("event",this.jobCardForm.value)

  }


  async getDataFromKey(list, formKey, key, value) {
    let index = list.findIndex(list_ => list_[key].toLowerCase() == formKey.toLowerCase());
    if (index != -1) {
      return list[index][value];
    } else {
      return "";
    }

  }

  async selectPrestart() {

    const modal = await this.modalController.create(
      SelectPrestartItemsPage,
      {
        fleetId: this.jobCardForm.value.plant_item,
        list: this.allPrestartData,
        selectedList: this.jobCardForm.value.commentValidation,
        isKlmr:true
      },
      { enableBackdropDismiss: false }
    );
    modal.onDidDismiss((data) => {
      if(data){

        this.allPrestartData = data;
        this.preStartItemList = data.filter((element) => {
          return element.isChecked === true
        });
        this.jobCardForm.setControl('commentValidation', this.formBuilder.array([]));
        for (let item of this.preStartItemList) {
          console.log("item",item)
          const commentForm = this.formBuilder.group({
            title: item.title,
            comment: [ item.comment],
            file:  item.file,
            completed_by: item.completed_by,
            completed_name: [ item.completed_name],
            base64:  item.base64,
            id: item.id,
            dbId: item.dbId,
            imagePrefix: item.imagePrefix,
            isCheck:item.isCheck,
            isBase64:item.isBase64,
            finalBase64:item.finalBase64,
          });
          this.comments.push(commentForm)
        }
        console.log('jobCardForm', this.jobCardForm.value.commentValidation);
        console.log('comments', this.comments);
      }
    });
    await modal.present();
  }



  get comments() {
    return this.jobCardForm.controls['commentValidation'] as FormArray;
  }
  async getComment(id,user_id) {
    let formData: FormData = new FormData();
    // formData.append("method_name", "comments");
    // formData.append("id", id);
    formData.append("method_name", "get_normal_jobcard_comments");
    formData.append("jobcard_id", id);
    formData.append("user_id",  this.jobCardForm.value.user_id);
    return this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);

        if (result.status) {
          this.commentList = result.result;
        }else{
          this.commentList = []
        }
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  async deleteComment(data){
    let formData: FormData = new FormData();
    formData.append("method_name", "delete_normal_comment");
    formData.append("id", data.id);
    return this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.getComment(this.params.id,this.params.user_id);
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  async updateComment(data) {

    let option = {
      "title": 'Comment',
      "approveText": 'save',
      "key": 'comment',
      "data":data.comment
    };
    let comment: any = await this.utiltiy.commentInputDialog(option);
    if(!comment){
      return;
    }
    let formData: FormData = new FormData();

    formData.append("method_name", "update_normal_comment");
    formData.append("jobcard_id", this.params.id);
    formData.append("comment_id",  data.id);
    formData.append("jobcard_comment", comment);
    return this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.getComment(this.params.id,this.params.user_id);
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }
  async addComment() {
    let formData: FormData = new FormData();
    let comment =  this.jobCardForm.value.comment
  

    formData.append("method_name", "save_normal_comment");
    formData.append("jobcard_id", this.params.id);
    formData.append("user_id",  this.jobCardForm.value.user_id);
    formData.append("comment", comment);
    return this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.jobCardForm.get(`comment`).setValue("");
        this.getComment(this.params.id,this.params.user_id);
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  async getJobNumberData() {
    return this.api.get(`/prestart/Job_code`, false)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          return result.result;
        }else{
          return [];
        }
        // return true;
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }
  async getData(methodName) {
    let formData: FormData = new FormData();
    formData.append("method_name", methodName);
    return this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        if (methodName == "requested_list") {
          result.result.forEach(element => {
            element.name = element.firstName + " " + element.surname;
          });
        }
        if (result.status) {
          return result.result;
        }else{
          return [];
        }
        // return true;
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }
  async getDataPrestart(methodName, id) {
    let formData: FormData = new FormData();
    formData.append("method_name", methodName);
    formData.append("jobcard_id", id);
    return this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        // if (methodName == "requested_list") {
        //   result.result.forEach(element => {
        //     element.name = element.firstName + " " + element.surname;
        //   });
        // }
        if (result.status) {
          return result;
        }else{
          var obj= {
            result: []
          }
          return obj;
        }
        // return true;
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }
  async getDataPrestartItems(methodName, id) {
    let formData: FormData = new FormData();
    formData.append("method_name", methodName);
    formData.append("fleet_no", id);
    return this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          let returnResult = result.result.length > 0?result.result[0].vehicles:[];
          return returnResult;
        }else{
          let returnResult = [];
          return returnResult;
        }
        // return true;
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  jobChanged(id) {
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "job_no");
    formData.append("job_no", id);
    this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          this.jobCardForm.get(`job_no`).setValue(result.result);
        } else {
          this.utiltiy.toaster(result.message);
        }
        this.utiltiy.stopLoading();

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  dropDownChange(value, key) {
    this.jobCardForm.get(`${key}`).setValue(value);
    if (key == "job_type") {
      this.checkJobType(this.selectedJobtype);
    } else if (key == "plant_item") {
      this.getFleetData(value, "id");
    }
  }

  async checkJobType(id) {
    // this.reset = true;
    let i = this.jobTypeList.findIndex(list_ => list_.job_type == id);
    if (i != -1) {
      if (this.jobTypeList[i].service_status == "True") {
        this.status = "At Service";
      } else {
        this.status = "";

      }
    } else {
      this.status = "";

    }
    this.reset = false;

  }

  submit() {
    
    if(this.selectedStatus != 'Closed'){
      this.jobCardForm.get(`out_date`).setValue("");
    }
    
    let formKeys = Object.keys(this.jobCardForm.value);
    let formData: FormData = new FormData();
    if (this.isUpdate) {
      formData.append("method_name", "jobcard_update");
      // formData.append("status", "Active");
      formData.append("jobcard_id", this.params.id);
      formKeys.forEach(key => {
        if (key != "commentValidation") {
          formData.append(key, this.jobCardForm.value[key]);
        }
      });
      this.jobCard(formData,"update",false);
    } else {
      formData.append("method_name", "jobcard_store_data");
      // formData.append("status", "Active");
      formKeys.forEach(key => {
        if (key != "commentValidation") {
          formData.append(key, this.jobCardForm.value[key]);
        }
      });
      this.jobCard(formData,"create",false);
    }
  }
  Prestartsubmit() {
    let formKeys = Object.keys(this.jobCardForm.value);
    let formData: FormData = new FormData();
    if (this.isUpdate) {
      formData.append("method_name", "jobcard_update");
      // formData.append("status", "Active");
      formData.append("jobcard_id", this.params.id);
      formKeys.forEach(key => {
        if (key != "commentValidation") {
          formData.append(key, this.jobCardForm.value[key]);
        }
      });
      this.TimeSHeetjobCard(formData,"update",true);
    } else {
      formData.append("method_name", "jobcard_store_data");
      // formData.append("status", "Active");
      formKeys.forEach(key => {
        if (key != "commentValidation") {
          formData.append(key, this.jobCardForm.value[key]);
        }
      });
      this.TimeSHeetjobCard(formData,"create",true);
    }
  }

  async addTimeSheet() {
    if (!this.jobCardForm.get('job_no').valid) {
      this.utiltiy.toaster("Select Job Number")
      return;
    }
    this.Prestartsubmit();
    let note = null;
    console.log(" this.jobCardForm.value", this.jobCardForm.value)
    this.jobCardForm.value.commentValidation.forEach(element => {
      if(element.isCheck){
        note = note == null?element.title+"-"+element.comment:note+","+element.title+"-"+element.comment;
      }
    });
    // this.navCtrl.setRoot(KlmrJobcardPage);
    this.navCtrl.push(KlmrTimesheetCreateAddPage, { param: null, copy: false, jobData: { job_no: this.jobCardForm.value.job_no, job_description: this.jobCardForm.value.job_description,notes:note } });

    // const modal = await this.modalController.create(KlmrTimesheetCreateAddPage, { param: null, copy: false, jobData: { job_no: this.jobCardForm.value.job_no, job_description: this.jobCardForm.value.job_description,notes:note } });
    // await modal.present();
  }
  TimeSHeetjobCard(formData,type,status) {
    // this.utiltiy.startLoading();
    this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        // this.utiltiy.stopLoading();
        if (result.status) {
          if (this.jobCardForm.value.commentValidation.length > 0) {
            if(type == "create"){
              this.TiimeSheetjobPrestartItems(result.result_id,type);
            }else{
              this.TiimeSheetjobPrestartItems(this.params.id,type);
            }
          } else {
            this.utiltiy.toaster(result.message);
           
          }

        } else {
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }
  jobCard(formData,type,status) {
    this.utiltiy.startLoading();
    this.disableSubmit = true;

    this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.status) {
          if (this.jobCardForm.value.commentValidation.length > 0) {
            if(type == "create"){
              this.jobPrestartItems(result.result_id,type);
            }else{
              this.jobPrestartItems(this.params.id,type);
            }
          } else {
            this.utiltiy.toaster(result.message);
            if(!status){
              this.navCtrl.setRoot(KlmrJobcardPage);
            }
          }

        } else {
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  TiimeSheetjobPrestartItems(id,type) {
    let formData: FormData = new FormData();

    this.jobCardForm.value.commentValidation.forEach((element,i) => {
      formData.append("item[]", element.id);
      formData.append("comment[]", element.comment);
      formData.append("completed_by[]", element.completed_by);
      console.log("element.file",element.file)
      if(type != "create"){
        formData.append("id[]", element.dbId);
        if (element.file != "") {
          let valueIs = element.isBase64?"Y":element.file
          formData.append("photo[]", element.file);
          formData.append("photo_change[]", valueIs);
        } else {
          const file = new File([], "", {});
          formData.append("photo[]", file);
          formData.append("photo_change[]", "Y");

        }


      }else{
        formData.append("id[]","");
        if (element.file != "") {
          formData.append("photo[]", element.file);
        } else {
          const file = new File([], "", {});
          formData.append("photo[]", file);
        }

      }
    
    });
    if(type == "create"){
      formData.append("method_name", "store_prestart_items_from_jobcard");
    }else{
      formData.append("method_name", "prestart_items_update_from_new_jobcard");
    }
    formData.append("jobcard_id", id);
    formData.append("fleet_no", this.jobCardForm.value.plant_item);
    formData.append("user_id", this.jobCardForm.value.user_id);
    // formData.append("completed_by", this.jobCardForm.value.completed_by);
    
    // this.utiltiy.startLoading();
    this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        // this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          // this.navCtrl.setRoot(KlmrJobcardPage);
        } else {
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  jobPrestartItems(id,type) {

    let formData: FormData = new FormData();

    this.jobCardForm.value.commentValidation.forEach((element,i) => {
      console.log("element",element)
      formData.append("item[]", element.id);
      formData.append("comment[]", element.comment);
      formData.append("completed_by[]", element.completed_by);
      console.log("element.file",element.file)
      if(type != "create"){
        formData.append("id[]", element.dbId);
        if (element.file != "") {
          let valueIs = element.isBase64?"Y":element.file
          formData.append("photo[]", element.file);
          formData.append("photo_change[]", valueIs);
        } else {
          const file = new File([], "", {});
          formData.append("photo[]", file);
          formData.append("photo_change[]", "Y");

        }


      }else{
        formData.append("id[]","");
        if (element.file != "") {
          formData.append("photo[]", element.file);
        } else {
          const file = new File([], "", {});
          formData.append("photo[]", file);
        }

      }
    
    });
    if(type == "create"){
      formData.append("method_name", "store_prestart_items_from_jobcard");
    }else{
      formData.append("method_name", "prestart_items_update_from_new_jobcard");
    }
    formData.append("jobcard_id", id);
    formData.append("fleet_no", this.jobCardForm.value.plant_item);
    formData.append("user_id", this.jobCardForm.value.user_id);
    // formData.append("completed_by", this.jobCardForm.value.completed_by);
    
    // this.utiltiy.startLoading();
    this.api.post(`/prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrJobcardPage);
        } else {
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err);
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }


  async getPermission() {
    this.actionAllowed = await this.utiltiy.getPagePermission("klmr-jobcard-rw");
    console.log("actionAllowed", this.actionAllowed);
  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

  async openModal(list, title, key, value, model, formkey) {
    list = await this.createData(list, key, value);
    console.log("list", list)
    console.log("formkey", formkey)
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(async data => {
      console.log(data);
      if (data) {

        this.jobCardForm.get(formkey).setValue(data.key);
        this[model] = data.value;
        if (formkey == "job_type") {
          this.firstTime = false;
          this.checkJobType(this[model]);
        } else if (formkey == "plant_item") {
          this.firstTime = false;
          this.getFleetData(data.key, "id");
        }

        if(formkey == "job_status"){
          console.log("1")
          if(data.value == "Closed"){
            console.log("2")
            let userId = await this.utiltiy.getStorage("userId");
            let userName = await this.utiltiy.getStorage("name");
           
            if (userName) {
              this.selectedCompletd = userName;
              this.jobCardForm.get(`completed_by`).setValue(userId);
            }
          }
        }

        

        if(formkey == "job_type"){
          if(this.selectedStatus == 'Closed'){
            let currentDate = new Date();
            var d = new Date();
            let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
            let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
            let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
            let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
            let outDate = year + "-" + month + "-" + day;
            this.jobCardForm.get(`out_date`).setValue(outDate);
          }
        }
        // this.jobNumber = data.job_no;
        // this.dropDownChange(data.job_no,'job_no');
      }
    });
    profileModal.present();

  }

  async deleteName(i,name){
    let completedName = [];
    let index = this.completedList.findIndex(list_ => list_.Person.toLowerCase() == name.toLowerCase());
    let completed_by = this.jobCardForm.value.commentValidation[i].completed_by;

    this.jobCardForm.value.commentValidation[i].completed_name.forEach(element => {
        if(name != element){
          completedName.push(element);
        }
    });
    
    if(index != -1){
      let j = completed_by.indexOf(this.completedList[index].id);
      let finalCompletedBy = "";
        if(j == 0){
          finalCompletedBy  = completed_by.replace(this.completedList[index].id, "")
        }else{
          finalCompletedBy  = completed_by.replace(","+this.completedList[index].id, "")

        }
      ((this.jobCardForm.get('commentValidation') as FormArray).at(i) as FormGroup).get("completed_name").patchValue(completedName);
      ((this.jobCardForm.get('commentValidation') as FormArray).at(i) as FormGroup).get("completed_by").patchValue(finalCompletedBy);
    }

    console.log("his.jobCardForm",this.jobCardForm)
  }

  async openModalCompleted(i,listing) {
    console.log(listing,"  this.jobCardForm.value.commentValidation[i]", this.jobCardForm.value.commentValidation[i])
    let finalList = [];
    this.completedList.forEach(element => {
      let index = listing.findIndex(list_ => list_.toLowerCase() == element.Person.toLowerCase());
      if(index == -1){
        finalList.push(element);
      }
    });
    
    let list = await this.createData(finalList, 'id', 'Person');
    console.log("list", list)
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: "Completed By" } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(data);
      if (data) {
        console.log(">=", this.jobCardForm.value.commentValidation[i].completed_by);
        let completedBy = this.jobCardForm.value.commentValidation[i].completed_by;
        let completedName = this.jobCardForm.value.commentValidation[i].completed_name;
        completedName.push(data.value);
        if(completedBy.length == 0){
          completedBy = data.id;
        }else{
          completedBy = completedBy+","+data.id;
        }
        ((this.jobCardForm.get('commentValidation') as FormArray).at(i) as FormGroup).get("completed_name").patchValue(completedName);
        ((this.jobCardForm.get('commentValidation') as FormArray).at(i) as FormGroup).get("completed_by").patchValue(completedBy);

    
        console.log("his.jobCardForm",this.jobCardForm)

        // this.jobNumber = data.job_no;
        // this.dropDownChange(data.job_no,'job_no');
      }
    });
    profileModal.present();

  }

  async openImage(img) {
    const modal = await this.modalController.create(SelectImagePopupPage, { param: img });
    await modal.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/klmr-jobcard-add/klmr-jobcard-add.ts